import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { detectLocale } from "@/i18n/translations";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index";
import Checklist from "./pages/Checklist";
import Guides from "./pages/Guides";
import GuideArticle from "./pages/GuideArticle";
import NotFound from "./pages/NotFound";
import LandingContentPage from "./pages/LandingContentPage";
import { LANDING_PAGES } from "@/content/landingPages";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/" element={<Navigate to={`/${detectLocale()}`} replace />} />
            <Route path="/en/wedding-planning-checklist" element={<Checklist forcedLocale="en" />} />
            <Route path="/fr/checklist-mariage" element={<Checklist forcedLocale="fr" />} />
            {LANDING_PAGES.flatMap((page) =>
              (["en", "fr"] as const).map((loc) => (
                <Route
                  key={`${page.id}-${loc}`}
                  path={`/${loc}/${page.path[loc]}`}
                  element={<LandingContentPage pageId={page.id} locale={loc} />}
                />
              )),
            )}
            <Route path="/:locale/guides" element={<Guides />} />
            <Route path="/:locale/guides/:slug" element={<GuideArticle />} />
            <Route path="/:locale" element={<Index />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
